export const GET_COUNTRIES = 'locationEpic/GET_COUNTRIES';
export const GET_COUNTRIES_SUCCESS = 'locationEpic/GET_COUNTRIES_SUCCESS';
export const GET_COUNTRIES_ERROR = 'locationEpic/GET_COUNTRIES_ERROR';

export const GET_CITIES = 'locationEpic/GET_CITIES';
export const GET_CITIES_SUCCESS = 'locationEpic/GET_CITIES_SUCCESS';
export const GET_CITIES_ERROR = 'locationEpic/GET_CITIES_ERROR';
